import { useContext } from "react";

import { CartContext, type CartApi } from "../CartContext";

/** The register's current basket (see `CartContext.tsx`). */
export function useCart(): CartApi {
  const cart = useContext(CartContext);
  if (!cart) {
    throw new Error("useCart() outside <CartProvider>");
  }
  return cart;
}
